import { useTranslation } from 'react-i18next'

import { Box, Grid, Typography } from '@mui/material'

import { useField } from 'formik'

import InputField from 'components/atoms/fields/InputField'

const StudentQuestionList = ({ fieldProps }) => {
  const [field] = useField(fieldProps.name)
  const { t } = useTranslation()

  return (
    <>
      <Typography variant='h5' sx={{ marginBottom: '1rem', textAlign: 'center' }}>{`${t('student.tell-us-more')}`}</Typography>
      <Box className='student-questions-container'>
        {field?.value.length > 0 && <div> {
          field?.value?.map((question: any, index: number) => (
            <div key={index} className='student-questions'>
              <div>
                {question.question}
              </div>
              <div>
                  <InputField
                      valueSelector='answer_text'
                      fieldProps={{
                        label: '',
                        name: `${fieldProps.name}[${index}]`,
                        required: true,
                      }}
                    />
              </div>
            </div>
          ))}</div>}
      </Box>
    </>
  )
}

export default StudentQuestionList
